import React from 'react';
import './styles/dhl-email.scss';
import { formatDate, resourcePath } from '../../../../utils/helpers';
import { observer } from 'mobx-react';
import { Trans, useTranslation } from 'react-i18next';
import { FlexDiv, Image } from '../../../design-system/containers';

function DhlEmail({ ui }) {
    const { t } = useTranslation('assessment');
    const today = new Date();
    const { email, personalizedData = {} } = ui;
    const { companyName = 'Mondelez International' } = personalizedData;
    const { text, footer, extraLogo } = email;
    return (
        <div className={'dhl-email'}>
            <div className="dhl-email--left">
                {extraLogo && (
                    <Image
                        src={resourcePath(extraLogo)}
                        alt={t('icon')}
                        height={21}
                    />
                )}
            </div>
            <div className="dhl-email--right">
                <div className="dhl-email--right--header">
                    {t('Parcel Arrival Notification')}
                </div>
                <div className="dhl-email--right--content">
                    <Trans
                        values={{
                            companyName,
                        }}
                        defaults={t(text, {
                            companyName,
                            today: formatDate(today),
                        })}
                        components={{
                            strong: <strong />,
                            themed: (
                                <div className="dhl-email--right--content__red" />
                            ),
                        }}
                    >
                        {t(text, {
                            companyName,
                            today: formatDate(today),
                        })}
                    </Trans>
                    {footer && (
                        <FlexDiv borderTop my={8} py={8}>
                            <div className="dhl-email--right--content__lighter">
                                {t(footer)}
                            </div>
                        </FlexDiv>
                    )}
                </div>
            </div>
        </div>
    );
}

export default observer(DhlEmail);
